export class CustomersSuppliersSettings {
    allowedFileTypes: string[] = [];


    deserialize(data: any): this {
        this.allowedFileTypes = (data.allowed_file_types ?? []) as string[];
        return this;
    }

    serialize(): any {
        return {
            allowed_file_types: this.allowedFileTypes,
        };
    }
}
